
    import { Component, Prop, Vue } from 'vue-property-decorator'
    import SimpleTable from '@/app/common/components/simple-table.vue'
    import { mapState } from 'vuex'
    import { Consumer } from '@/app/identity'
    import { PurchaseIntention } from '@/app/purchase-intention/entities/purchase-intention.entity'

    @Component({
        components: { SimpleTable },
        computed: {
            ...mapState('auth', ['consumer'])
        }
    })
    export default class PurchaseIntentionOverview extends Vue {
        @Prop({ type: PurchaseIntention, required: true }) purchaseIntention!: PurchaseIntention

        consumer!: Consumer
    }
